import { Trans } from '@lingui/macro';
import ContactInformationGraphic from './images/contact-information-graphic.svg';

interface Props {
    children: string | JSX.Element;
}

export default function OnBoardingCompleted({ children }: Props) {
    return (
        <>
            <div className="mb-8">{children}</div>
            <div className="flex flex-col justify-center items-center">
                <img src={ContactInformationGraphic} className="mb-4 h[207px] w[230px]" />
                <strong className="mb-4">
                    <Trans>Onboarding is continued in Lager by Rackbeat</Trans>
                </strong>
                <p className="mb-4">
                    <Trans>
                        Didn't get redirected to Lager by Rackbeat? We're always here to help. Check your browser for a tab called
                        Rackbeat.
                    </Trans>
                </p>
            </div>
        </>
    );
}
